import React from 'react';
import BaseComponent from 'src/components/BaseComponent';

import constants from 'src/constants';

import { getSelectLabel, lang } from 'src/helpers';

class VitalInfo extends BaseComponent {
  render() {
    const { patient } = this.props;
    return (
      <div className={'mc-container-content__body'}>
        <div className={'mc-container-content__body-content mc-flex-15-col'}>
          <div className={'mc-flex'}>
            <div className={'mc-value-618'}>{lang.t('Vital Information')}</div>
          </div>
          <div className={'mc-flex'}>
            <div className={'mc-flex-col mc-grow'}>
              <div className={'mc-label-416'}>{lang.t('Blood group')}</div>
              <div className={'mc-value-518'}>
                {getSelectLabel(constants.general.blood_groups, patient.vitalInfo?.bloodGroup)}
                &nbsp;
              </div>
            </div>
            <div className={'mc-flex-col mc-grow'}>
              <div className={'mc-label-416'}>{lang.t('RH (Rhesus factor)')}</div>
              <div className={'mc-value-518'}>
                {getSelectLabel(constants.general.rhesus_factors, patient.vitalInfo?.rhesusFactor)}
                &nbsp;
              </div>
            </div>
          </div>
          <div className={'mc-flex-col'}>
            <div className={'mc-label-416'}>{lang.t('Allergies')}</div>
            <pre className={'mc-value-518'}>{patient.vitalInfo?.allergies}&nbsp;</pre>
          </div>
        </div>
      </div>
    );
  }
}

export default VitalInfo;
